<nav class="navbar">
  <a routerLink="/" class="logo-container">
    <img src="assets/on_home.png" alt="ASAPP Logo" class="logo-img" />
    <div class="logo-text">
      <span class="company-name">ASAPP</span>
      <span class="tagline">SOFTWARE SOLUTIONS</span>
    </div>
  </a>
 
  <ul class="nav-links">
    <li><a routerLink="/">Home</a></li>
    <li><a routerLink="/about">About</a></li>
    <li><a routerLink="/projects">Projects</a></li>
    <li><a routerLink="/contact">Contact</a></li>
  </ul>
</nav>
